import { render, staticRenderFns } from "./reliefs.vue?vue&type=template&id=d3b22e7e&"
import script from "./reliefs.vue?vue&type=script&lang=js&"
export * from "./reliefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports